const state = () => ({
  formLangKey: '',
  formNameUrl: '',
  gtmFormName: '',
  isProgramActive: true
});

const getters = {
  formLangKey(state) {
    return state.formLangKey;
  },
  formNameUrl(state) {
    return state.formNameUrl;
  },
  gtmFormName(state) {
    return state.gtmFormName;
  },
  isProgramActive(state) {
    return state.isProgramActive;
  }
};

const mutations = {
  setFormParams(state, payload) {
    state.formNameUrl = payload.formNameUrl;
    state.formLangKey = payload.formLangKey;
    state.gtmFormName = payload.gtmFormName;
  },
  setIsProgramActive(state, payload) {
    state.isProgramActive = payload;
  }
};

const actions = {
  async setFormParams({ commit }, payload) {
    const formParams = {
      formLangKey: '',
      formNameUrl: '',
      gtmFormName: ''
    };

    switch (payload.name) {
      case 'linka-o-migrene':
        formParams.formLangKey = 'migraine';
        formParams.formNameUrl = 'Migraine';
        formParams.gtmFormName = 'dotaznik-migrena';
        break;
      case 'lupenka':
        formParams.formLangKey = 'psoriasis';
        formParams.formNameUrl = 'psoriasis';
        formParams.gtmFormName = 'dotaznik-psoriaza';
        break;
      case 'dlya-ukrayiny':
      case 'dlya-ukrainy':
        formParams.formLangKey = 'putinSucks';
        formParams.formNameUrl = payload.lang === 'ru' ? 'ukrajina-ru' : 'ukrajina-uk';
        formParams.gtmFormName = 'dotaznik-ukrajina';
        break;
      case 'aeskulab':
        formParams.formLangKey = 'aeskulab';
        formParams.formNameUrl = 'AeskuLab';
        formParams.gtmFormName = 'aeskulab';
        break;
    }

    commit('setFormParams', formParams);
  }
};

export const thematicCounselling = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
